export enum MigrationType {
  CasesMigration = "casesMigration",
  CaseFoldersMigration = "caseFoldersMigration",
  ProvidersMigration = "providersMigration",
  FirmDocumentsMigration = "firmDocumentsMigration",
  TemplatesMigration = "templatesMigration",
  IntakesMigration = "intakesMigration",
  ProviderFoldersMigration = "providerFoldersMigration",
}

export const MigrationTypeLabels: Record<MigrationType, string> = {
  [MigrationType.CasesMigration]: "Cases",
  [MigrationType.CaseFoldersMigration]: "Case Folders",
  [MigrationType.ProvidersMigration]: "Providers",
  [MigrationType.FirmDocumentsMigration]: "Firm Documents",
  [MigrationType.TemplatesMigration]: "Templates",
  [MigrationType.IntakesMigration]: "Intakes",
  [MigrationType.ProviderFoldersMigration]: "Provider Folders",
};

/**
 * What one entity of a discovery is called in a sentence, singular and plural. The source-link copy renders on all
 * five tabs, so it takes the tab's own noun rather than saying "entity", which means nothing to a reader.
 */
export const MigrationTypeNouns: Record<MigrationType, { one: string; many: string }> = {
  [MigrationType.CasesMigration]: { one: "case", many: "cases" },
  [MigrationType.CaseFoldersMigration]: { one: "case folder", many: "case folders" },
  [MigrationType.ProvidersMigration]: { one: "provider", many: "providers" },
  [MigrationType.FirmDocumentsMigration]: { one: "folder", many: "folders" },
  [MigrationType.TemplatesMigration]: { one: "template library", many: "template libraries" },
  [MigrationType.IntakesMigration]: { one: "intake", many: "intakes" },
  [MigrationType.ProviderFoldersMigration]: { one: "provider folder", many: "provider folders" },
};

/** The noun for a count: "1 case", "3 cases". */
export const nounFor = (type: MigrationType, count: number): string =>
  count === 1 ? MigrationTypeNouns[type].one : MigrationTypeNouns[type].many;
